import { ReactNode } from 'react';

import { ProductRedirector } from '../../views/product-redirector/product-redirector';
import RobotsView from '../../views/robots/robots-view';
import JiraUserSegmentationView from '../../views/user-seg-bxp-ui/user-segmentation';
import { LegacyConfirmationPageLayout } from '../../views/view-switch';
import { PerceivedProvisioningStartTimer } from '../perceived-provisioning/perceived-provisioning-start-timer';

import { PROVISIONING, ProvisioningScreenKey, TEAM_CHOICE } from './utils';

export type ScreenList = ProvisioningScreenKey[];
export const teamChoiceDictionaryItem = {
	[TEAM_CHOICE]: <JiraUserSegmentationView />,
} as const;
export const provisioningUIDictionaryItem = {
	[PROVISIONING]: (
		<PerceivedProvisioningStartTimer>
			<ProductRedirector>
				<LegacyConfirmationPageLayout>
					<RobotsView />
				</LegacyConfirmationPageLayout>
			</ProductRedirector>
		</PerceivedProvisioningStartTimer>
	),
} as const;
export type ScreenDictionary = Partial<Record<ProvisioningScreenKey, ReactNode>>;

export const defaultScreenDictionary: ScreenDictionary = {
	...teamChoiceDictionaryItem,
	...provisioningUIDictionaryItem,
};
